import { ContentPage } from "../common/cms/ContentPage";
import { AccountManagementPage } from "../features/auth/AccountManagementPage";
import { CheckLoginPage } from "../features/auth/CheckLoginPage";
import { LoginPage } from "../features/auth/LoginPage";
import { RequireAuth } from "../features/auth/RequireAuth";
import LandingPage from "../features/home/LandingPage";
import PrivacyNoticePage from "../features/home/PrivacyNoticePage";
import { CountryLanguageSelectionPage } from "../features/location/CountryLanguageSelectionPage";
import ManagementPanelPage from "../features/management/ManagementPanelPage";
import { IntroToPlan } from "../features/plan/IntroToPlan";
import { PlanPage } from "../features/plan/PlanPage";
import { ContentPreviewPage } from "../features/preview/ContentPreviewPage";
import { RegionPreviewPage } from "../features/preview/RegionPreviewPage";
import QuestionnairePage from "../features/questionnaire/QuestionnairePage";
import { IntroToRecommendations } from "../features/recommendations/IntroToRecommendations";
import RecommendationsPage from "../features/recommendations/RecommendationsPage";
import { CalculationBasisPage } from "../features/results/CalculationBasisPage";
import ResultsPage from "../features/results/ResultsPage";
import { InitializationWrapper } from "./InitializationWrapper";
import { CompletedTestProtector } from "./routeProtectors/CompletedTestProtector";
import { Outlet, Route, Routes } from "react-router-dom";

const RequireTestCompletion = () => (
  <CompletedTestProtector>
    <Outlet />
  </CompletedTestProtector>
);

export const AppRoutes = () => (
  <Routes>
    <Route element={<InitializationWrapper />}>
      <Route path="/" element={<LandingPage />} />
      <Route path="/campaign/:campaignId" element={<LandingPage />} />
      <Route path="/selections" element={<CountryLanguageSelectionPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountManagementPage />
          </RequireAuth>
        }
      />
      <Route
        path="/managementpanel"
        element={
          <RequireAuth>
            <ManagementPanelPage />
          </RequireAuth>
        }
      />
      <Route path="/test" element={<QuestionnairePage />} />

      <Route path="/results" element={<ResultsPage />} />
      <Route element={<RequireTestCompletion />}>
        <Route path="/recommendations" element={<RecommendationsPage />} />
        <Route
          path="/recommendations/intro"
          element={<IntroToRecommendations />}
        />
        <Route path="/plan" element={<PlanPage />} />
        <Route path="/plan/intro" element={<IntroToPlan />} />
      </Route>

      <Route path="/privacynotice" element={<PrivacyNoticePage />} />
      <Route path="/calculationbasis" element={<CalculationBasisPage />} />
    </Route>
    <Route path="/checklogin" element={<CheckLoginPage />} />
    <Route path="/preview/region" element={<RegionPreviewPage />} />
    <Route path="/preview/content" element={<ContentPreviewPage />} />
    <Route path="*" element={<ContentPage />} />
  </Routes>
);
